import {
  Box,
  BoxProps,
  ChakraComponent,
  Flex,
  Heading,
  Stack,
  Table,
  TableProps,
  Tbody,
  Thead,
  useBreakpointValue,
  useColorModeValue,
} from '@chakra-ui/react';
import { ComponentType, ReactNode } from 'react';
import { PaginationBar, PaginationSettings } from './PaginationBar';

export interface AppTableProps {
  title: ReactNode;
  header: JSX.Element;
  body: JSX.Element;
  pagination: PaginationSettings;
  // buttonGroup?: ReactNode;
  buttonGroup?: ComponentType<BoxProps>;
  onPaginationChange: (settings: { page: number; size: number }) => void;
}

const Internal = (props: AppTableProps) => {
  const {
    title,
    header,
    body,
    pagination,
    buttonGroup: ButtonGroup,
    onPaginationChange,
  } = props;
  const { page, size } = pagination;

  return (
    <Box
      bg="bg-surface"
      boxShadow={{ base: 'none', md: useColorModeValue('sm', 'sm-dark') }}
      borderRadius={useBreakpointValue({ base: 'none', md: 'lg' })}
    >
      <Stack spacing="5">
        <Box px={{ base: '4', md: '6' }} pt="5">
          <Flex>
            <Heading
              size={useBreakpointValue({ base: 'xs', md: 'sm' })}
              fontWeight={'medium'}
              flexGrow={1}
            >
              {title}
            </Heading>
            {/* <InputGroup maxW="xs">
              <InputLeftElement pointerEvents="none">
                <Icon as={FiSearch} color="muted" boxSize="5" />
              </InputLeftElement>
              <Input placeholder="Search" />
            </InputGroup> */}
            {ButtonGroup && <ButtonGroup pl={4} />}
          </Flex>
          {/* <Stack
            direction={{ base: 'column', md: 'row' }}
            justify="space-between"
          ></Stack> */}
        </Box>
        <Box overflowX="auto">
          <Table>
            <Thead>{header}</Thead>
            <Tbody>{body}</Tbody>
          </Table>
        </Box>
        <PaginationBar
          {...pagination}
          onPageChange={(page) => onPaginationChange({ page, size })}
          onPageSizeChange={(size) => onPaginationChange({ page: 1, size })}
        />
      </Stack>
    </Box>
    // </Container>
  );
};

export const AppTable = Internal as ChakraComponent<'div', AppTableProps>;
